module.exports = __webpack_public_path__ + "img/GAME_COLORLOTUS.dac55f9e.jpg";